export enum CUSTOMER_TYPE {
  INDIVIDUAL = 'INDIVIDUAL',
  BUSINESS = 'BUSINESS',
}

export const CUSTOMER_TYPE_OPTIONS = [
  { label: 'Individual', value: 'INDIVIDUAL' },
  { label: 'Business', value: 'BUSINESS' },
]
